import CustomSelect from '../../../common/components/CustomSelect';
import CustomTextArea from '../../../common/components/CustomTextAera';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeModificationFormView2ModificationItemViewFieldName =
  'modification_item1'|'modification_item2'|'modification_item3'|
  'modification_details1'|'modification_details2'|'modification_details3';

export default function KaraokeModificationFormView2ModificationItemView({
  itemName,
  detailsName,
  getValue,
  setValue,
  getErrors,
} : {
  itemName: KaraokeModificationFormView2ModificationItemViewFieldName,
  detailsName: KaraokeModificationFormView2ModificationItemViewFieldName,
  getValue: (name: KaraokeModificationFormView2ModificationItemViewFieldName) => string,
  setValue: (name: KaraokeModificationFormView2ModificationItemViewFieldName, value: string) => void,
  getErrors: (name: KaraokeModificationFormView2ModificationItemViewFieldName) => FieldValidationErrorsType,
}) {
  const options = [
    { value: 'アーティスト名', title: 'アーティスト名' },
    { value: 'アーティスト名読み', title: 'アーティスト名読み' },
    { value: '作詞者', title: '作詞者' },
    { value: '作曲者', title: '作曲者' },
    { value: '曲名', title: '曲名' },
    { value: '曲名読み', title: '曲名読み' },
    { value: '申込者名', title: '申込者名' },
    { value: '歌詞', title: '歌詞' },
    { value: '音源', title: '音源' },
    { value: '映像', title: '映像' },
  ];
  return (
    <>
      <dl>
        <dt>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>修正項目</label>
        </dt>
        <dd>
          <CustomSelect
            options={options}
            value={getValue(itemName)}
            setValue={(value) => setValue(itemName, value)}
            validationErrors={getErrors(itemName)}
          />
        </dd>
      </dl>
      <dl>
        <dt>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>修正内容</label>
        </dt>
        <dd>
          <CustomTextArea
            rows={5}
            value={getValue(detailsName)}
            setValue={(value) => setValue(detailsName, value)}
            validationErrors={getErrors(detailsName)}
          />
          <p className="text_info_on">
            音源、映像を選択した場合は、差し替えたいファイルをギガファイル便などにアップロードし、そのURLを記載してください。
          </p>
        </dd>
      </dl>
    </>
  );
}
